import { render } from "./Plant.vue?vue&type=template&id=761235b5"
import script from "./Plant.vue?vue&type=script&lang=js"
export * from "./Plant.vue?vue&type=script&lang=js"

import "./Plant.vue?vue&type=style&index=0&id=761235b5&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__